import StartPage from "./components/Main/Main";
import './App.css';

function App() {
  return (
        <StartPage/>

  );
}

export default App;
